import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-background: ${props => props.theme.background};
    --color-background-secondary: ${props => props.theme.backgroundSecondary};
    --color-text: ${props => props.theme.text};
    --color-text-secondary: ${props => props.theme.textSecondary};
    --color-text-muted: ${props => props.theme.textMuted};
    --color-border: ${props => props.theme.border};
    --color-button-primary: ${props => props.theme.buttonPrimary};
    --color-button-success: ${props => props.theme.buttonSuccess};
    --color-status-pending: ${props => props.theme.statusPending};
  }

  body {
    background: ${props => props.theme.background};
    color: ${props => props.theme.text};
  }

  /* When logged in, prevent the window/document from scrolling — scroll happens inside the app Main container */
  body.app--no-window-scroll {
    overflow: hidden;
  }

  /* Custom Scrollbar - Theme-aware */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.scrollbarTrack};
    border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.scrollbarThumb};
    border-radius: 6px;
    border: 2px solid ${props => props.theme.scrollbarTrack};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.scrollbarThumbHover};
  }

  ::-webkit-scrollbar-corner {
    background: ${props => props.theme.scrollbarTrack};
  }

  /* Firefox scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.scrollbarThumb} ${props => props.theme.scrollbarTrack};
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${props => props.theme.text};
  }
`;

export default GlobalStyles;
